import React from 'react'

import { Item } from 'components/common/Dropdown/styles'
import Text from 'components/common/Text'
import { emitOpenAVSettings } from 'helpers/events'

const menu = {
    icon: `/assets/revamp/av-troubleshoot.svg`,
    alt: 'troubleshoot',
    copy: 'Audio/video troubleshoot',
}

const AVTroubleshoot = () => {
    return (
        <Item.Area onClick={emitOpenAVSettings}>
            <Item.Icon>
                <img src={menu.icon} alt={menu.alt} />
            </Item.Icon>
            <Item.Copy>
                <Text level="3" bold={false}>
                    {menu.copy}
                </Text>
            </Item.Copy>
        </Item.Area>
    )
}

export default AVTroubleshoot
